import { render, staticRenderFns } from "./ProjectCustomField.vue?vue&type=template&id=11fb356c&"
import script from "./ProjectCustomField.vue?vue&type=script&lang=js&"
export * from "./ProjectCustomField.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCustomField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports